import { render } from "./EmpDet.vue?vue&type=template&id=91fd05e0&scoped=true"
import script from "./EmpDet.vue?vue&type=script&lang=js"
export * from "./EmpDet.vue?vue&type=script&lang=js"

import "./EmpDet.vue?vue&type=style&index=0&id=91fd05e0&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91fd05e0"]])

export default __exports__